export const BUTTON_TYPE = {
  Button: 'button',
  Submit: 'submit',
} as const;

export const BUTTON_VARIANT = {
  Primary: 'primary',
  PrimaryOutline: 'primary-outline',
  Secondary: 'secondary',
  Text: 'text',
  ErrorLink: 'error-link',
  AuthSubmit: 'authSubmit',
  AuthResend: 'authResend',
  AuthSubmitBlue: 'authSubmitBlue',
  AuthResendBlue: 'authResendBlue',
} as const;

export const BUTTON_SIZE = {
  Large: 'large',
  Medium: 'medium',
  Small: 'small',
} as const;

export const BUTTON_TEXT_ALIGN = {
  Left: 'left',
  Center: 'center',
  Right: 'right',
};

export const BUTTON_BUSINESS_UNIT = {
  Corporate: 'corporate',
  Blocks: 'blocks',
  Mortgage: 'mortgage',
  Newsletter: 'newsletter',
  NavMortgage: 'navMortgage',
  SubscribeMortgage: 'subscribeMortgage',
  ProfileMortgage: 'profileMortgage',
};
